import { useContext } from "react";
import { RootObjectContext } from "../context/RootObjectContext";
/**
 * Get the root cfg object
 * - requires {@linkcode ConfigurationController}
 * @category Hook
 * @category CsCfgObject
 * @export
 * @template TCfgObject Allows specifying additional properties on the cfg object
 * @returns {TCfgObject}
 */
export function useRootCfgObject() {
    return useContext(RootObjectContext);
}
//# sourceMappingURL=useRootCfgObject.js.map